import { __awaiter } from "tslib";
import { extractSubFromJwt, getOrCreateSessionId } from './webchat.helper';
let lastUserSub;
function initCognigyWebchat(endpointUrl, cognigySource, options, accessTokenProvider) {
    return __awaiter(this, void 0, void 0, function* () {
        if (typeof window === 'undefined') {
            throw new Error('Window object not available');
        }
        if (!window.initWebchat) {
            yield new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = cognigySource;
                script.async = true;
                script.onload = () => resolve();
                script.onerror = () => reject(new Error('Failed to load Cognigy Webchat script'));
                document.head.appendChild(script);
            });
        }
        if (!window.initWebchat) {
            throw new Error('initWebchat function not found after script load');
        }
        const webchat = yield window.initWebchat(endpointUrl, options);
        if (typeof webchat.registerAnalyticsService === 'function') {
            webchat.registerAnalyticsService((event) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                switch (event.type) {
                    case 'webchat/outgoing-message':
                        break;
                    case 'webchat/incoming-message': {
                        if ((_b = (_a = event.payload.data) === null || _a === void 0 ? void 0 : _a.retrieveData) === null || _b === void 0 ? void 0 : _b.JWT) {
                            const jwt = accessTokenProvider ? yield accessTokenProvider() : null;
                            const sub = extractSubFromJwt(jwt);
                            if (sub && sub !== lastUserSub && webchat.updateSettings) {
                                webchat.updateSettings({ userId: sub });
                                lastUserSub = sub;
                            }
                            if (webchat.sendMessage) {
                                yield webchat.sendMessage('', { accessToken: jwt });
                            }
                        }
                        break;
                    }
                    default:
                        break;
                }
            }));
        }
        return webchat;
    });
}
let webchatInstance = null;
let webchatInitPromise = null;
export function createCognigyWebchatService(endpointUrl, cognigySource, accessTokenProvider) {
    if (!webchatInitPromise) {
        const sessionId = getOrCreateSessionId();
        webchatInitPromise = initCognigyWebchat(endpointUrl, cognigySource, {
            channel: 'webchat-client',
            sessionId,
            settings: {
                behavior: {
                    enableSTT: true,
                    enableTTS: false,
                },
            },
        }, accessTokenProvider).then(instance => {
            webchatInstance = instance;
            return webchatInstance;
        });
    }
    return {
        open: () => {
            webchatInitPromise === null || webchatInitPromise === void 0 ? void 0 : webchatInitPromise.then(w => w.open && w.open());
        },
        close: () => {
            webchatInitPromise === null || webchatInitPromise === void 0 ? void 0 : webchatInitPromise.then(w => w.close && w.close());
        },
        sendMessage: (text, data) => {
            return webchatInitPromise
                ? webchatInitPromise.then(w => w.sendMessage ? w.sendMessage(text, data) : Promise.reject('sendMessage not available'))
                : Promise.reject('Webchat not initialized');
        },
    };
}
